import Chevron from 'components/Chevron';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import React, { useState } from 'react';
import { getCta } from 'utils/common';
import { colors } from 'utils/constants';

const LeaderboardPrize = [
  {
    points: 350,
    subscriberPoints: 700,
    name: <>Refer a Friend</>,
    expandedSection: (
      <>
        <ul>
          <li>
            350 points awarded per <strong>successful</strong> referral
          </li>
        </ul>

        <Link
          href="/account/referrals"
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}>
          
            Refer friend now →
          
        </Link>
      </>
    ),
  },
  {
    points: 300,
    subscriberPoints: 600,
    name: <>Video Testimonial</>,
    expandedSection: (
      <>
        <ul>
          <li>
            300 points awarded when you send us a video testimonial that is at
            least <strong>30 seconds</strong> long and filmed in{' '}
            <strong>landscape</strong> ideally showing us what you've won
          </li>
          <li>
            You agree that we can use/share your video for marketing purposes
          </li>
        </ul>

        <a
          href="mailto:hello@daymade.co.uk"
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}
        >
          Drop us an email with your video →
        </a>
      </>
    ),
  },
  {
    points: 150,
    subscriberPoints: 300,
    name: <>Follow us on Instagram</>,
    expandedSection: (
      <>
        <ul>
          <li>
            150 points awarded when you follow us on{' '}
            <a
              href="https://www.instagram.com/daymadeuk/"
              target="_blank"
              style={{ margin: 0, color: 'white', fontWeight: '900' }}
            >
              Instagram
            </a>
          </li>
          <li>
            Please drop us an email with your Instagram handle once you've done
            so
          </li>
          <li>
            These points will automatically roll over each month if you continue
            to follow us on Instagram
          </li>
        </ul>

        <a
          href="https://www.instagram.com/daymadeuk/"
          target="_blank"
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}
        >
          Follow us on Instagram →
        </a>
      </>
    ),
  },
  {
    points: 150,
    subscriberPoints: 300,
    name: <>Complete our Feedback Form</>,
    expandedSection: (
      <>
        <ul>
          <li>150 points awarded when you complete our feedback form</li>
          <li>Please drop us an email once you've done so</li>
        </ul>

        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSftHew388HmBTUMwYO7gVc-bQuoEaSrJfWTpg0Fuk3Wx_ecag/viewform?usp=sf_link"
          target="_blank"
          rel="noreferrer"
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}
        >
          Complete the form →
        </a>
      </>
    ),
  },
  {
    points: 100,
    subscriberPoints: 200,
    name: <>Refer a Friend (non-Premium)</>,
    freemiumOnly: true,
    expandedSection: (
      <>
        <ul>
          <li>
            100 points awarded per successful free referral (i.e. when the
            person you referred starts a free subscription)
          </li>
        </ul>

        <Link
          href="/account/referrals"
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}>
          
            Refer a friend now →
          
        </Link>
      </>
    ),
  },
  {
    points: 75,
    subscriberPoints: 150,
    name: <>Exchange DAYMADE Token For Points</>,
    expandedSection: (
      <>
        <ul>
          <li>
            75 points awarded <strong>per DAYMADE Token</strong>.
          </li>
          <li>Redeem your Tokens for Leaderboard points from your account.</li>
          <li>
            These points are only awarded if you exchange your DAYMADE token
            for: planting a tree + 3 Leaderboard Raffle entries
          </li>
        </ul>

        <Link
          href="/account?action=redeem-tokens"
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}>
          
            Redeem Tokens for Leaderboard points →
          
        </Link>
      </>
    ),
  },
  {
    points: 75,
    subscriberPoints: 150,
    name: <>Enter a Weekly Draw</>,
    expandedSection: (
      <>
        <ul>
          <li>
            75 points awarded <strong>per entry</strong> for each draw that you
            enter
          </li>
          <li>Applies to paid entries and postal entries</li>
        </ul>

        <Link
          href={getCta()?.url}
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}>
          
            Enter Weekly Draw →
          
        </Link>
      </>
    ),
  },
  {
    points: 50,
    subscriberPoints: 100,
    name: <>Enter Token Town Raffle</>,
    expandedSection: (
      <>
        <ul>
          <li>
            50 points awarded <strong>per entry</strong>
          </li>
          <li>Online/postal entries are included</li>
        </ul>

        <Link
          href="/token-town"
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}>
          
            Enter Token Town Raffle →
          
        </Link>
      </>
    ),
  },
  {
    points: 25,
    subscriberPoints: '—',
    name: <>Enter a Weekly Draw for free</>,
    expandedSection: (
      <>
        <ul>
          <li>
            25 points awarded if you are a free subscriber to our Friday Weekly
            Draw
          </li>
        </ul>

        <Link
          href={getCta()?.url}
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}>
          
            Enter Weekly Draw →
          
        </Link>
      </>
    ),
  },
  {
    points: 25,
    subscriberPoints: 50,
    name: <>Enter Free Daily Draw</>,
    expandedSection: (
      <>
        <ul>
          <li>
            25 points awarded <strong>per play</strong>
          </li>
        </ul>

        <Link
          href="/token-town/free-daily-draw"
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}>
          
            Enter Free Daily Draw →
          
        </Link>
      </>
    ),
  },
  {
    points: 0,
    subscriberPoints: 1000,
    name: <>Subscriber BONUS</>,
    expandedSection: (
      <>
        <ul>
          <li>
            Get 1,000 points for being a <strong>Premium</strong> or{' '}
            <strong>Lite subscriber</strong>.
          </li>
          <li>
            These points carry over for <strong>every month</strong> that you
            have a Premium or Lite subscription into one or both of our Weekly
            Draws.
          </li>
        </ul>

        <Link
          href={getCta()?.url}
          style={{
            fontWeight: 600,
            textAlign: 'right',
            color: 'white',
            margin: '0 0 1em 0',
            fontStyle: 'italic',
          }}>
          
            Subscribe now →
          
        </Link>
      </>
    ),
  },
];

const LeaderboardPrizeRow = ({ action, isFreemiumSubscriber }) => {
  if (action.freemiumOnly && !isFreemiumSubscriber) {
    return null;
  }

  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <tr onClick={() => setExpanded(!expanded)}>
        <td>{action.name}</td>
        <td style={{ textAlign: 'center', fontStyle: 'italic' }}>
          {action.subscriberPoints}
        </td>
        <td style={{ textAlign: 'center', fontStyle: 'italic' }}>
          {action.points}
        </td>
        <td>
          <Chevron
            direction="down"
            reversed={expanded}
            style={{
              fontSize: '1em',
              marginRight: '1em',
              height: 'auto',
              color: 'white',
            }}
          />
        </td>

        <style jsx>{`
          tr {
            font-weight: 600;
            cursor: pointer;
          }

          td {
            padding: 2em 0;
          }
        `}</style>
      </tr>

      {expanded && (
        <tr>
          <td colSpan={4} style={{ paddingBottom: '2em' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {action.expandedSection}
            </div>
          </td>
        </tr>
      )}

      <tr>
        <td colSpan={4}>
          <div
            style={{
              height: '2px',
              backgroundColor: colors.brand.neon,
              boxShadow: `0 0 8px ${colors.brand.shadow}`,
              flexGrow: 1,
            }}
          />
        </td>
      </tr>
    </>
  );
};

const LeaderboardPrizeTable = observer(() => {
  const { currentUser } = useUserStore();
  const isFreemiumSubscriber = currentUser?.subscriberStatus === 'FREEMIUM';

  return (
    <table>
      <thead>
        <tr style={{ textTransform: 'uppercase' }}>
          <th style={{ textAlign: 'left' }}>Action</th>
          <th>Premium/Lite Subscriber Points</th>
          <th>
            {isFreemiumSubscriber
              ? 'Non-Premium/Lite Points'
              : 'Non-Subscriber Points'}
          </th>
        </tr>
      </thead>

      <tbody style={{ fontWeight: '600' }}>
        <tr>
          <td colSpan={4}>
            <div
              style={{
                height: '2px',
                backgroundColor: colors.brand.neon,
                boxShadow: `0 0 8px ${colors.brand.shadow}`,
                flexGrow: 1,
              }}
            />
          </td>
        </tr>

        {LeaderboardPrize.map((action, i) => (
          <React.Fragment key={i}>
            <LeaderboardPrizeRow
              action={action}
              isFreemiumSubscriber={isFreemiumSubscriber}
            />
          </React.Fragment>
        ))}
      </tbody>

      <style jsx>{`
        table {
          color: white;
          border-collapse: separate;
          border-spacing: 0;
          width: 100%;
          max-width: 1000px;
        }

        th {
          padding: 1em;
        }

        @media (max-width: 350px) {
          th {
            font-size: 0.9em;
            padding: 0.5em;
          }
        }
      `}</style>
    </table>
  );
});

export default LeaderboardPrizeTable;
